import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-documentation.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-documentation.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../app-controller.service";
import { AlertType } from "../../shared/models/alert";
import { BehaviorSubject } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { AppConfig } from "../../app.config";
import { Validators } from "@angular/forms";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { ViewApplicationBaseComponent } from "../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../shared/application-view.service";
import { DeleteDocumentsConfirmationDialogComponent } from "../shared/forms/delete-documents-confirmation-dialog/delete-documents-confirmation-dialog.component";
import { AddDocumentsDialogComponent } from "../shared/forms/add-documents-dialog/add-documents-dialog.component";
import { EditDocumentsDialogComponent } from "../shared/forms/edit-documents-dialog/edit-documents-dialog.component";
import { ViewApplicationConstants } from "../shared/view-application.constants";
import { ViewApplicationDocumentationConstants } from "./view-application-documentation.constants";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { FileUtils } from "../../shared/utils/file-utils";
import { take } from "rxjs/operators";
import { ApiAttachmentConstants } from "../../shared/constants/api-constants/api-attachment.constants";
import { FileService } from "../../shared/services/file/file.service";
let ViewApplicationDocumentationComponent = class ViewApplicationDocumentationComponent extends ViewApplicationBaseComponent {
    aflaModuleStrategyService;
    applicationViewService;
    selectedApplicationService;
    modalService;
    datePipe;
    changeDetectorRef;
    appController;
    routerParamsService;
    fileService;
    disableComponent = true;
    showNoRequiredDocumentText = false;
    tableMapper;
    tableDataSource = new BehaviorSubject([]);
    documentForm;
    stepHeader = "";
    requiredDocuments = [];
    optionalDocuments = [];
    showOptionalDocuments = false;
    showCheckBoxColumn = true;
    noRequiredDocumentText = ViewApplicationDocumentationConstants.NO_DOCUMENT_REQUIRED_MESSAGE;
    uploadRequiredDocumentLabel = ViewApplicationDocumentationConstants.UPLOAD_REQUIRED_DOC_LABEL;
    uploadOptionalDocumentLabel = ViewApplicationDocumentationConstants.UPLOAD_OPTIONAL_DOC_LABEL;
    applicationDocumentsLabel = ViewApplicationDocumentationConstants.APPLICATIONS_DOCUMENTS_LABEL;
    optionalDocumentsLabel = ViewApplicationDocumentationConstants.OPTIONAL_DOCUMENTS_LABEL;
    addBtnLabel = ViewApplicationDocumentationConstants.ADD_DOCUMENTS_BTN_LABEL;
    editBtnLabel = ViewApplicationDocumentationConstants.EDIT_DOCUMENTS_BTN_LABEL;
    deleteBtnLabel = ViewApplicationDocumentationConstants.DELETE_DOCUMENTS_BTN_LABEL;
    modalBodyOptions = ViewApplicationDocumentationConstants.modalBodyOptions;
    attachmentLabel = ViewApplicationDocumentationConstants.ATTACHMENT_LABEL;
    downloadLabel = ViewApplicationDocumentationConstants.DOWNLOAD_LABEL;
    componentName = ViewApplicationDocumentationConstants.COMPONENT_NAME;
    requiredDocumentLookupConstant = ViewApplicationDocumentationConstants.REQUIRED_DOCUMENTS_HEADING_LOOKUP;
    sessionDocumentCantBeDeletedMsg = ViewApplicationDocumentationConstants.SESSION_DOCUMENTS_CANT_BE_DELETED_MESSAGE;
    sessionDocumentCantBeEditedMsg = ViewApplicationDocumentationConstants.SESSION_DOCUMENTS_CANT_BE_EDITED_MESSAGE;
    addDocumentDialogTitle = ViewApplicationDocumentationConstants.ADD_DOCUMENTS_DIALOG_TITLE;
    editDocumentDialogTitle = ViewApplicationDocumentationConstants.EDIT_DOCUMENTS_DIALOG_TITLE;
    deleteDocumentDialogTitle = ViewApplicationDocumentationConstants.DELETE_DOCUMENTS_DIALOG_TITLE;
    datePipeDateFormat = ViewApplicationDocumentationConstants.DATE_PIPE_FORMAT;
    documentFormControl = ViewApplicationDocumentationConstants.DOCUMENT_FORM_CONTROL_NAME;
    documentsFormControl = ViewApplicationDocumentationConstants.DOCUMENTS_FORM_CONTROL_NAME;
    additionalApplicationTypeConstant = ViewApplicationDocumentationConstants.ADDITIONAL_APPLICATION_TYPE_CONSTANTS;
    isDocumentRequiredConstant = ViewApplicationDocumentationConstants.IS_DOCUMENT_REQUIRED;
    noRequiredDocumentsFoundErrMsg = ViewApplicationDocumentationConstants.NO_REQUIRED_DOCUMENTS_FOUND_MESSAGE;
    optionalDocumentsHeader = ViewApplicationDocumentationConstants.OPTIONAL_DOCUMENTS_HEADER;
    selectedApplicationApplicationTypes = [];
    selectedDocuments = [];
    documentTypes = [];
    configUploadSettings;
    currentApplication;
    savedDocumentsIds;
    deleteUploadDocumentsObservableSubscription;
    getLookupsObservableSubscription;
    selectedModuleNameAsObservableSubscription;
    getAttachmentsSubscription;
    getApplicationTypesSubscription;
    selectedApplicationSubscription;
    isApplicationClosed = true;
    constructor(aflaModuleStrategyService, applicationViewService, selectedApplicationService, modalService, datePipe, changeDetectorRef, appController, routerParamsService, fileService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.applicationViewService = applicationViewService;
        this.selectedApplicationService = selectedApplicationService;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.fileService = fileService;
        this.configUploadSettings = AppConfig.settings.uploadFile;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.initForm();
        this.getIsApplicationClosed();
        this.setupSubscribers();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    arrayReturned(documents) {
        this.selectedDocuments = documents;
    }
    getIsApplicationClosed() {
        this.applicationViewService.getIsApplicationClosed(+this.appController.selectedModuleID, +this.jobId)
            .pipe(take(1))
            .subscribe({
            next: (result) => {
                this.isApplicationClosed = result;
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Delete);
            }
        });
    }
    onDeleteBtnClicked() {
        if (this.selectedDocuments.length === 0) {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.disableComponent && this.checkIfDocumentCanBeAltered()) {
            this.appController.showMessage(this.sessionDocumentCantBeDeletedMsg, AlertType.Warning);
            return;
        }
        const modalRef = this.modalService.open(DeleteDocumentsConfirmationDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.deleteDocumentDialogTitle;
        modalRef.componentInstance.documentsToDelete = this.selectedDocuments;
        modalRef.result.then((deletedDocuments) => {
            if (deletedDocuments) {
                const idsOfDocumentsToBeDeleted = this.selectedDocuments.map(document => {
                    return document.id;
                });
                const params = {
                    ids: idsOfDocumentsToBeDeleted,
                    moduleId: this.currentApplication.moduleId
                };
                this.deleteUploadDocumentsObservableSubscription = this.applicationViewService.deleteUploadDocumentsObservable(params).subscribe({
                    next: () => {
                        this.deleteSelectedDocsFromTable(idsOfDocumentsToBeDeleted);
                        this.updateDocumentChecklist();
                        this.updateFormControl();
                        this.selectedDocuments = [];
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Delete);
                    }
                });
            }
        });
    }
    onAddBtnClicked(event) {
        if (this.isApplicationClosed === true) {
            this.appController.showMessage(ViewApplicationDocumentationConstants.CLOSED_APPLICATION, AlertType.Warning);
            return;
        }
        const evt = event.target;
        this.documentTypes = this.getDocumentTypes();
        const modalRef = this.modalService.open(AddDocumentsDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.addDocumentDialogTitle;
        modalRef.componentInstance.documentTypes = this.documentTypes;
        modalRef.componentInstance.configUploadSettings = this.configUploadSettings;
        modalRef.componentInstance.currentApplication = this.currentApplication;
        modalRef.componentInstance.selectedDocumentType = evt.innerHTML;
        modalRef.result.then((newDocument) => {
            if (newDocument) {
                this.addDocumentToTable(newDocument);
                this.updateDocumentChecklist();
                this.updateFormControl();
                this.selectedDocuments = [];
                this.changeDetectorRef.markForCheck();
            }
        });
    }
    onEditBtnClicked() {
        if (this.isApplicationClosed === true) {
            this.appController.showMessage(ViewApplicationDocumentationConstants.CLOSED_APPLICATION, AlertType.Warning);
            return;
        }
        if (this.selectedDocuments.length === 0) {
            this.appController.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.selectedDocuments.length > 1) {
            this.appController.showMessage(SharedConstants.MORE_THAN_ONE_SELECTED, AlertType.Warning);
            return;
        }
        if (this.disableComponent && this.checkIfDocumentCanBeAltered()) {
            this.appController.showMessage(this.sessionDocumentCantBeEditedMsg, AlertType.Warning);
            return;
        }
        this.documentTypes = this.getDocumentTypes();
        const modalRef = this.modalService.open(EditDocumentsDialogComponent, this.modalBodyOptions);
        modalRef.componentInstance.dialogTitle = this.editDocumentDialogTitle;
        modalRef.componentInstance.documentToEdit = this.selectedDocuments[0];
        modalRef.componentInstance.documentTypes = this.documentTypes;
        modalRef.componentInstance.currentApplication = this.currentApplication;
        modalRef.componentInstance.configUploadSettings = this.configUploadSettings;
        modalRef.result.then((resultObject) => {
            if (resultObject) {
                this.deleteSelectedDocsFromTable(resultObject.idsToDelete);
                this.addDocumentToTable(resultObject.editedDocument);
                this.updateDocumentChecklist();
                this.updateFormControl();
                this.selectedDocuments = [];
            }
        });
    }
    onDownloadAttachment(attachment) {
        const fileUrl = `${ApiAttachmentConstants.URL}/${attachment.id}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`;
        this.fileService.download(fileUrl).then(blob => {
            FileUtils.openFile(attachment.fileName, blob);
        });
    }
    checkIfDocumentCanBeAltered() {
        // checks if the selected documents should be deleted or edited
        let preventDocumentEdit = false;
        const docsThatCantBeAltered = [];
        for (const selectedDocument of this.selectedDocuments) {
            if (this.savedDocumentsIds.indexOf(selectedDocument.id) >= 0) {
                docsThatCantBeAltered.push(selectedDocument);
            }
        }
        if (docsThatCantBeAltered.length > 0) {
            preventDocumentEdit = true;
        }
        return preventDocumentEdit;
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = this.requiredDocumentLookupConstant;
    }
    getRequiredDocumentsLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationViewService.moduleID} and name eq 'RequiredDocument' and deleted eq false`,
            $expand: "attachment"
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                if (response && response.hasOwnProperty("value") && response.value.length > 0) {
                    const lookups = response.value;
                    this.onGetRequiredDocumentsLookupsCompleted(lookups);
                }
                else {
                    this.loadSavedAttachments(this.currentApplication.attachments);
                    this.updateDocumentChecklistOnInit(this.tableDataSource.value);
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    onGetRequiredDocumentsLookupsCompleted(lookups) {
        this.requiredDocuments = [];
        this.optionalDocuments = [];
        this.showOptionalDocuments = false;
        this.buildRequiredDocumentsObjects(lookups);
        this.sortRequiredDocumentsAlphabetically();
        // optional documents
        this.requiredDocuments.forEach((doc) => {
            if (doc.optionalUpload?.toLowerCase().trim() === "yes") {
                this.optionalDocuments.push(doc);
            }
        });
        if (this.optionalDocuments.length > 0) {
            this.showOptionalDocuments = true;
        }
        this.requiredDocuments = this.requiredDocuments.filter(docs => docs.optionalUpload?.toLowerCase() !== "yes");
        if (this.currentApplication.attachments.length > 0) {
            this.loadSavedAttachments(this.currentApplication.attachments);
            this.updateDocumentChecklistOnInit(this.tableDataSource.value);
        }
        this.updateFormControl();
        if (this.disableComponent) {
            this.captureIdsOfDocuments();
        }
        this.changeDetectorRef.detectChanges();
    }
    buildRequiredDocumentsObjects(lookups) {
        lookups.forEach(lookup => {
            const content = JSON.parse(lookup.content);
            if (this.selectedApplicationApplicationTypes.length > 0) {
                this.selectedApplicationApplicationTypes.forEach((applicationType) => {
                    if (content.category && content.applicationType !== this.additionalApplicationTypeConstant &&
                        content.required?.toLowerCase() === this.isDocumentRequiredConstant &&
                        content.applicationType?.toLowerCase() === applicationType?.toLowerCase()) {
                        this.appendRequiredDocuments(lookup, content);
                    }
                });
            }
            else {
                if (content.category && content.applicationType !== this.additionalApplicationTypeConstant &&
                    content.required?.toLowerCase() === this.isDocumentRequiredConstant) {
                    this.appendRequiredDocuments(lookup, content);
                }
            }
        });
        if (this.requiredDocuments.length > 0) {
            this.removeDuplicateDocuments();
        }
    }
    addDocumentToTable(document) {
        // adds new document into the table
        const documentsAlreadyOnTheTable = this.tableDataSource.value;
        if (documentsAlreadyOnTheTable.length > 0) {
            documentsAlreadyOnTheTable.push(document);
            this.tableDataSource.next([...documentsAlreadyOnTheTable]);
        }
        else {
            this.tableDataSource.next([document]);
        }
    }
    updateDocumentChecklist() {
        const docsInTable = this.tableDataSource.value;
        this.resetDocumentsChecklist();
        this.updateDocumentChecklistOnInit(docsInTable);
    }
    deleteSelectedDocsFromTable(idsOfDocumentsToBeDeleted) {
        const documentsAlreadyOnTheTable = this.tableDataSource.value;
        const newDocuments = [];
        documentsAlreadyOnTheTable.forEach((document) => {
            let deleteDocument = false;
            idsOfDocumentsToBeDeleted.forEach((documentIdOfDeletedDocument) => {
                if (document.id === documentIdOfDeletedDocument) {
                    deleteDocument = true;
                }
                if (!deleteDocument) {
                    newDocuments.push(document);
                }
            });
        });
        this.tableDataSource.next([...newDocuments]);
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            // gets the saved application by jobId (if it exists)
            if (application) {
                if (+this.jobId > 0) {
                    this.getApplicationAttachments(application);
                }
            }
        });
    }
    setupSubscribers() {
        this.getStepHeadingSubscribers();
        this.subscribeToSelectedApplication();
    }
    getStepHeadingSubscribers() {
        this.selectedModuleNameAsObservableSubscription = this.applicationViewService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${ViewApplicationConstants.REQUIRED_DOCUMENTATION_HEADING}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.documentFormControl);
        form.clearValidators();
        this.documentForm = form;
    }
    loadSavedAttachments(attachments) {
        const attachmentsForTable = [];
        attachments.forEach((attachment) => {
            const attachmentObject = {
                id: attachment.id,
                type: attachment.attachmentType,
                name: attachment.description,
                dateUploaded: this.datePipe.transform(attachment.date, this.datePipeDateFormat),
                fileName: attachment.fileName,
                source: attachment.source,
            };
            attachmentsForTable.push(attachmentObject);
        });
        this.tableDataSource.next(attachmentsForTable);
    }
    updateFormControl() {
        // mark form as valid if all required documents are uploaded
        let formIsValid = true;
        if (this.showNoRequiredDocumentText) {
            formIsValid = true;
        }
        this.requiredDocuments.forEach((document) => {
            if (document.uploaded === false) {
                formIsValid = false;
            }
        });
        if (formIsValid) {
            this.documentForm.get(this.documentsFormControl).clearValidators();
        }
        else {
            this.documentForm.get(this.documentsFormControl).addValidators(Validators.required);
        }
        this.documentForm.markAllAsTouched();
        this.documentForm.get(this.documentsFormControl).updateValueAndValidity();
    }
    getApplicationAttachments(application) {
        // get the application's attachments
        const params = {
            jobId: application.jobId
        };
        this.getAttachmentsSubscription = this.applicationViewService.getAttachments(params).subscribe({
            next: (response) => {
                application.attachments = response.value;
                this.getApplicationTypes(application);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    updateDocumentChecklistOnInit(attachmentsForTable) {
        if (this.requiredDocuments.length > 0 && attachmentsForTable.length > 0) {
            this.requiredDocuments.forEach((requiredDocument) => {
                attachmentsForTable.forEach((attachment) => {
                    if (requiredDocument.name?.toLowerCase().trim() === attachment.type?.toLowerCase().trim()) {
                        requiredDocument.uploaded = true;
                    }
                });
            });
        }
        if (this.optionalDocuments.length > 0 && attachmentsForTable.length > 0) {
            this.optionalDocuments.forEach((optionalDocument) => {
                attachmentsForTable.forEach((attachment) => {
                    if (optionalDocument.name?.toLowerCase().trim() === attachment.type?.toLowerCase().trim()) {
                        optionalDocument.uploaded = true;
                    }
                });
            });
        }
    }
    getDocumentTypes() {
        this.documentTypes = [this.additionalApplicationTypeConstant];
        const requiredTypes = this.requiredDocuments?.map(document => {
            return document.name;
        });
        requiredTypes.forEach((type) => {
            this.documentTypes.push(type);
        });
        const optionalTypes = this.optionalDocuments?.map(document => {
            return document.name;
        });
        optionalTypes.forEach((type) => {
            this.documentTypes.push(type);
        });
        return this.documentTypes;
    }
    getApplicationTypes(application) {
        const jobId = +this.jobId;
        const moduleId = +this.appController.selectedModuleID;
        this.getApplicationTypesSubscription = this.aflaModuleStrategyService.getApplicationTypes(jobId, moduleId).subscribe({
            next: (applicationTypes) => {
                this.selectedApplicationApplicationTypes = applicationTypes.value;
                this.currentApplication = application;
                this.getRequiredDocumentsLookups();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    sortRequiredDocumentsAlphabetically() {
        if (this.requiredDocuments.length > 0) {
            this.requiredDocuments?.sort((a, b) => a?.name.localeCompare(b.name));
        }
        else {
            this.showNoRequiredDocumentText = true;
        }
    }
    appendRequiredDocuments(lookup, content) {
        const fileName = lookup.attachment === null ? "" : lookup.attachment.fileName;
        this.requiredDocuments.push({
            id: lookup.id,
            uploaded: false,
            category: content.category,
            name: content.name,
            description: content.description,
            required: content.required,
            optionalUpload: content.optionalUpload,
            fileName,
            attachmentId: lookup.attachment === null ? 0 : lookup.attachment.id,
        });
    }
    resetDocumentsChecklist() {
        if (this.requiredDocuments.length > 0) {
            this.requiredDocuments.forEach((doc) => {
                doc.uploaded = false;
            });
        }
    }
    removeDuplicateDocuments() {
        // removes document objects that have the same 'name' property
        const uniqueRequiredDocuments = {};
        const distinctDocumentsArray = [];
        const optionalDocumentsArray = [];
        this.requiredDocuments.forEach((documentObject) => {
            if (!uniqueRequiredDocuments[documentObject.name]) {
                distinctDocumentsArray.push(documentObject);
                uniqueRequiredDocuments[documentObject.name] = true;
            }
        });
        this.requiredDocuments = distinctDocumentsArray;
        // get optional documents
        this.requiredDocuments.forEach((optionalDoc) => {
            if (optionalDoc.optionalUpload?.toLowerCase().trim() === "yes") {
                optionalDocumentsArray.push(optionalDoc);
            }
        });
    }
    captureIdsOfDocuments() {
        // capture the Ids of documents that should not be edited/ deleted
        const documents = this.tableDataSource.value;
        this.savedDocumentsIds = [];
        if (documents.length > 0) {
            // capture Id
            this.savedDocumentsIds = documents.map((document) => {
                return document.id;
            });
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ApplicationViewService },
        { type: SelectedApplicationService },
        { type: NgbModal },
        { type: DatePipe },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: FileService }
    ];
};
ViewApplicationDocumentationComponent = __decorate([
    Component({
        selector: "app-view-application-documentation",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDocumentationComponent);
export { ViewApplicationDocumentationComponent };
